export const CLOSE_MODAL = 'CLOSE_MODAL'
export const ERROR_MESSAGE = 'ERROR_MESSAGE'
export const OPEN_MODAL = 'OPEN_MODAL'